export default "__VITE_ASSET__B2vK2e7a__"